import { Theme } from '@mui/material/styles';
import { createStyles } from "@mui/styles";

const typographyStyle = (theme: Theme) => createStyles({
    defaultFontStyle: {
        fontSize: "14px",
    },
    defaultHeaderMargins: {
        marginTop: "20px",
        marginBottom: "10px"
    },
    quote: {
        padding: "10px",
        margin: "4px",
        fontSize: "1em",
        borderLeft: "5px solid #808080"
    },
    quoteText: {
        margin: "4px 0 4px 0",
        fontStyle: "italic"
    },
    quoteAuthor: {
        display: "block",
        fontSize: "80%",
        lineHeight: "1.42857143",
        color: "#777"
    },
});

export default typographyStyle;
